import api from "./axios";

export const ActivityLog = async ({ queryKey }) => {
  const [_key, { page, limit, filter, see_all }] = queryKey;
  const response = await api.get("/common/activities/", {
    params: { page, limit, filter, see_all },
  });
  return response.data.data;
};

export const clearActivityLog = async () => {
  const response = await api.post("/common/clear-activity/");
  return response.data.data;
};
